import {observer} from 'mobx-react';
import {FormattedMessage} from 'react-intl';
import {Modal, ModalButtons} from 'shared/components/modals';
import {FormLayout, Input, Button} from 'shared/components';

const EditDimensionModal = observer(({uiState, modalOpen}) => {
  const {errors, editingDimension} = uiState;

  return (
    <Modal
      isOpen={modalOpen}
      onHide={() => uiState.closeEditDimensionModal()}
      size='sm'
      title={editingDimension.isNew
        ? 'time_tracking.dimensions.Create Dimension'
        : 'time_tracking.dimensions.Edit Dimension'
      }
    >
      <FormLayout>
        <Input
          value={editingDimension.name}
          label='time_tracking.dimensions.Dimension name'
          errorMessage={errors.name}
          onChange={e => editingDimension.merge({name: e.target.value})}
        />
      </FormLayout>
      <div className='flex justify-content-between'>
        <div className='mt3'>
          {editingDimension.canDelete && <Button trait='destructive' onClick={() => uiState.openRemoveDimensionModal()}>
            <FormattedMessage id='time_tracking.dimensions.Remove'/>
          </Button>}
        </div>
        <ModalButtons onSave={() => uiState.saveDimension()} onCancel={() => uiState.closeEditDimensionModal()}/>
      </div>
    </Modal>
  );
});

export default EditDimensionModal;
